(function () {
  function initFaq(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    root.querySelectorAll('.product-faq-item > .title').forEach(function (title) {
      function toggle() {
        var item = title.closest('.product-faq-item');
        var text = item && item.querySelector('.text');
        var isOpen = title.classList.contains('open');

        title.classList.toggle('open', !isOpen);
        title.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (text) {
          if (isOpen) {
            text.setAttribute('hidden', '');
          } else {
            text.removeAttribute('hidden');
          }
        }
      }

      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-steamer-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
